import { Card, CardHeader } from "@mui/material";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import CreateClientForm from "./CreateClientForm";

// ----------------------------------------------------------------------

export const CreateClient = () => {
	const { translate } = useLocales();

	return (
		<Card sx={{ mt: 4 }}>
			<CardHeader
				avatar={<Iconify icon='mdi:user' />}
				sx={{ pb: 2.25 }}
				title={translate("Añadir clientes")}
			/>
			<CreateClientForm />
		</Card>
	);
};

export default CreateClient;
